import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    requestPasswordResetRequest,
    clearPasswordResetState,
} from "../../../redux/actions/emailActions";
import "./ForgotPasswordModal.css";

const ForgotPasswordModal = ({
                                 onClose,
                                 resetLoading,
                                 resetRequestMessage,
                                 resetError,
                                 requestPasswordReset,
                                 clearResetState,
                             }) => {
    const [identifier, setIdentifier] = useState("");

    useEffect(() => {
        return () => {
            clearResetState();
        };
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!identifier.trim()) return;

        requestPasswordReset(identifier.trim());
    };

    return (
        <div className="fpm-overlay" onClick={onClose}>
            <div className="fpm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="fpm-header">
                    <h3>Mot de passe oublié</h3>
                    <button type="button" onClick={onClose}>✕</button>
                </div>

                <p className="fpm-text">
                    Saisissez votre username ou votre email. Si le compte existe,
                    un lien de réinitialisation vous sera envoyé.
                </p>

                {resetRequestMessage && (
                    <div className="fpm-alert success">{resetRequestMessage}</div>
                )}

                {resetError && (
                    <div className="fpm-alert error">{resetError}</div>
                )}

                <form onSubmit={handleSubmit} className="fpm-form">
                    <input
                        type="text"
                        placeholder="Username ou email"
                        value={identifier}
                        onChange={(e) => setIdentifier(e.target.value)}
                        disabled={resetLoading}
                    />

                    <div className="fpm-actions">
                        <button
                            type="button"
                            className="secondary"
                            onClick={onClose}
                            disabled={resetLoading}
                        >
                            Annuler
                        </button>

                        <button type="submit" disabled={resetLoading || !identifier.trim()}>
                            {resetLoading ? "Envoi..." : "Envoyer le lien"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    resetLoading: state.emails?.resetLoading || false,
    resetRequestMessage: state.emails?.resetRequestMessage || "",
    resetError: state.emails?.resetError || null,
});

const mapDispatchToProps = (dispatch) => ({
    requestPasswordReset: (identifier) =>
        dispatch(requestPasswordResetRequest(identifier)),
    clearResetState: () => dispatch(clearPasswordResetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordModal);